<template>
    <v-dialog-old ref="dialog" id="notificationDialog">
        <fieldset>
            <legend>Уведомление</legend>

            <div class="notificationHeader">
                <span class="notificationTitle">
                    {{ notification.title }}
                </span>
                <span class="notificationDate">
                    {{ notification.created_at | formatDateTime }}
                </span>
            </div>

            <div class="notificationText" v-html="notification.text"/>
        </fieldset>
    </v-dialog-old>
</template>

<script>

export default {
    data() {
        return {
            notification: {},
        };
    },
    methods: {
        show (notification) {
            this.notification = notification;
            this.$refs.dialog.show();
        },
    }
}
</script>

<style>
#notificationDialog {
    width: 1000px;

    .notificationHeader {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0 10px;
        margin-bottom: 10px;
        line-height: 28px;

        .notificationTitle {
            font-size: 20px;
            margin-right: 5px;
        }

        .notificationDate {
            font-size: 16px;
            color: #666;
            white-space: nowrap;
        }
    }

    .notificationText {
        font-size: 16px;
        padding: 10px;
    }
}
</style>
